module.exports = __webpack_public_path__ + "static/media/201113-artwork-fashion-slashie-sylvie.6adb071e.jpg";